export default {
  vi: {
    user: "Người dùng",
    login: "Đăng nhập",
    logout: "Thoát",
    username: "Tên đăng nhập",
    usernameOrEmail: "Tên đăng nhập / email",

    signUpIAgreeWith: "Tôi đã đọc và đồng ý với các",
    signUpTermOfUse: "điều khoản sử dụng",
    and: "và",
    signUpPrivacyPolicy: "chính sách riêng tư",

    portalHome: "Trang chủ Portal",
    footerAttribution: "Sản phẩm của VNPT-IT",
    version: "Phiên bản",
    headerMenuAdmin: "Quản trị",
    serviceAdminAccount: "Tài khoản QTDV",
    saleAccount: "Tài khoản TTKD",
    customerAdminAccount: "Tài khoản quản trị khách hàng",
    application: "Ứng dụng",
    subscriptionPlan: "Gói cước",
    meeting: "Cuộc họp",
    meetingList: "Danh sách cuộc họp",
    manageMeetings: "Quản lý cuộc họp",
    viewOnly: "Chỉ xem",

    selectAll: "Chọn tất cả",
    deselectAll: "Bỏ chọn tất cả",

    done: "Đã thực hiện",
    inprogress: "Đang diễn ra",
    pending: "Đang chờ",
    cancelled: "Đã hủy",

    active: "Hoạt động",
    unactive: "Không hoạt động",

    all: "Tất cả",
    status: "Trạng thái",
    contact: "Danh bạ",
    chooseFromContacts: "Chọn từ danh bạ",
    manageAccount: "Quản lý tài khoản",
    manageServices: "Quản lý dịch vụ",
    emailTemplate: "Mẫu email",
    weeklyCalendar: "Lịch tuần",
    weeklyCalendarList: "Danh sách lịch tuần",
    meetingLocation: "Địa điểm họp",
    report: "Báo cáo",
    alert: "Thông báo",
    details: "Chi tiết",
    meetingCount: "Số lượng phiên họp",
    meetingCountDetails: "Chi tiết số lượng phiên họp",
    meetingCountTotal: "Tổng số lượng phiên họp",
    meetingDetailReport: "Báo cáo chi tiết cuộc họp",
    settings: "Cài đặt",
    passwordPolicy: "Chính sách mật khẩu",
    ipBlacklist: "Danh sách chặn IP",
    systemLogs: "Nhật ký hệ thống",
    backup1: "Sao lưu dự phòng",
    changeWebPort: "Đổi port website",
    manageConfigulation: "Quản lý hạ tầng",
    password: "Mật khẩu",
    currentPassword: "Mật khẩu hiện tại",
    newPassword: "Mật khẩu mới",
    confirmPassword: "Xác nhận mật khẩu",
    save: "Lưu",
    copy: "Sao chép",
    clone: "Nhân bản",
    change: "Thay đổi",
    saveChanges: "Lưu thay đổi",
    note: "Ghi chú",
    updateSuccessful: "Cập nhật thành công",
    createSuccessful: "Thêm mới thành công",
    passwordsNotMatch: "Mật khẩu không khớp",
    changePassword: "Đổi mật khẩu",
    unlockAccount: "Mở khoá tài khoản",
    resetPassword: "Đặt lại mật khẩu",
    forgotPassword: "Cấp mật khẩu mới",
    passwordChangedSuccessful: "Đổi mật khẩu thành công. Bạn vui lòng đăng nhập lại.",
    passwordResetSuccessful: "Đặt lại mật khẩu thành công",
    actionComplete: "Hoàn tất",
    fullName: "Họ và tên",
    phoneNumber: "Số điện thoại",
    invalidPhoneFormat: "Số điện thoại không đúng định dạng",
    address: "Địa chỉ",
    companyName: "Tên công ty",
    nameUnit: "Tên đơn vị",
    underTheUnit: "Thuộc đơn vị",
    ownedBy: "Thuộc sở hữu",
    province: "Tỉnh/thành phố",
    corporation: "Tổng công ty",
    invalidEmail: "Email không hợp lệ",
    account: "Tài khoản",
    corporations: "Tổng công ty",
    vinaphone: "Vinaphone",
    media: "Media",
    net: "NET",
    vt_ttp: "VT-TTP",
    tdagency: "Cơ quan TĐ",
    it: "IT",
    other: "Khác",
    outside: "Ngoài VNPT",
    invnpt: "Trong VNPT",
    pleaseChoose: "Vui lòng chọn",
    individual: "Cá nhân",
    enterprise: "Doanh nghiệp",
    organ: "Cơ quan nhà nước",
    packageStatus: "Trạng thái gói cước",
    or: "Hoặc",

    usernameDescription: "Chấp nhận ký tự chữ thường, in hoa và dấu gạch dưới _",
    createAccount: "Tạo tài khoản",
    createAccountSuccessful: "Tạo tài khoản thành công",
    createAdminAccountSuccessful: "Tạo tài khoản QTDV thành công",
    customerAdminAccountList: "Danh sách tài khoản quản trị khách hàng",
    createCustomerAdminAccount: "Tạo tài khoản quản trị phía khách hàng",
    createCustomerAdminAccountSuccessful: "Tạo tài khoản quản trị khách hàng thành công",
    createIpPolicySuccessful: "Thêm mới thành công",

    appName: "Tên ứng dụng",
    customer: "Khách hàng",
    customerAutofillPlaceholder: "tìm theo mã KH, tên, email hoặc SĐT",
    customerSearchPlaceholder: "mã KH, tên, email hoặc SĐT",
    meetingSearchPlaceholder: "Tìm theo mã, tên khách hàng",
    meetingDetailReportSearchPlaceholder: "Tìm theo tên cuộc họp, người tạo",
    search: "Tìm kiếm",
    advancefilter: "Bộ lọc nâng cao",
    clearFilter: "Xóa lọc",
    keyword: "Từ khoá",
    createApp: "Tạo ứng dụng",
    createAppSuccessful: "Tạo ứng dụng thành công",
    updateApp: "Cập nhật thông tin ứng dụng",
    updateAppSuccessful: "Cập nhật thông tin ứng dụng thành công",
    calendarLocationName: "Tên địa điểm",
    updateCalendarLocationSuccessful: "Cập nhật địa điểm thành công",
    createCalendarLocationSuccessful: "Thêm địa điểm thành công",
    workTitle: "Chức danh",
    workDepartment: "Phòng ban",
    workOrganization: "Đơn vị",
    workOrganizationName: "Tên đơn vị",
    downloadSampleFile: "Tải file mẫu",
    importFromFile: "Nhập danh bạ",
    importContactsFromFileSuccessful: "Nhập danh bạ thành công",
    createContactSuccessful: "Thêm liên lạc thành công",
    noData: "Không có dữ liệu",
    loadingData: "Đang tải dữ liệu...",
    chooseSubscription: "Chọn gói cước",
    subscriptionInfo: "Thông tin gói cước",
    subscriptionLength: "Thời gian sử dụng",
    maximumNumberOfParticipantsInMeeting: "Số người tối đa trong cuộc họp",
    numberOfConcurrentMeetings: "Số cuộc họp đồng thời",
    maximumLengthOfOneMeeting: "Thời lượng tối đa mỗi cuộc họp",
    numberOfMeetingsPerMonth: "Số cuộc họp trong 1 tháng",
    serviceInfo: "Thông tin dịch vụ",
    effDate: "Ngày hiệu lực",
    expDate: "Ngày hết hạn",
    selectEffDate: "Chọn ngày hiệu lực",
    selectExpDate: "Chọn ngày hết hạn",
    currentExpDate: "Ngày hết hạn hiện tại",
    expDateAfterRenew: "Ngày hết hạn sau khi gia hạn",
    servicePrice: "Giá cước",
    vatTax: "Thuế VAT",
    amountCustomerToPay: "Số tiền khách cần trả",
    registerConfirmCorrectInfo: "Vui lòng xác nhận các thông tin trên là chính xác trước khi thực hiện đăng ký dịch vụ",
    renewConfirmCorrectInfo: "Vui lòng xác nhận các thông tin trên là chính xác trước khi thực hiện gia hạn dịch vụ",
    upgradeConfirmCorrectInfo: "Vui lòng xác nhận các thông tin trên là chính xác trước khi thực hiện thay đổi dịch vụ",
    renewService: "Gia hạn dịch vụ",
    cancelService: "Hủy dịch vụ",
    renewServiceSuccess: "Gia hạn dịch vụ thành công",
    cancelServiceSuccess: "Hủy dịch vụ thành công",
    subscriptionToRegister: "Gói cước đăng ký",
    serviceStartDate: "Ngày bắt đầu sử dụng dịch vụ",

    cancelServiceConfirm: "Bạn có chắc muốn hủy dịch vụ?",

    hours: "giờ",
    minutes: "phút",
    days: "Ngày",
    weeks: "Tuần",
    months: "Tháng",
    years: "Năm",
    maximum: "Tối đa",
    register: "Đăng ký",

    agree: "Đồng ý",
    disagree: "Không đồng ý",

    registerService: "Đăng ký dịch vụ",
    registerServiceSuccessful: "Đăng ký dịch vụ thành công",
    subscriptionToUpgradeTo: "Gói cước đăng ký",
    upgradeOption: "Hình thức thay đổi",
    upgradeOption0: "Sử dụng đến ngày kết thúc của gói đang sử dụng",
    upgradeOption1: "Thêm thời gian sử dụng",
    upgradeDurationExtension: "Số {unit} sử dụng thêm",
    upgradeService: "Thay đổi dịch vụ",
    upgradeServiceSuccessful: "Thay đổi dịch vụ thành công",
    meetingParticipant: "Người tham gia",
    addMeetingParticipant: "Thêm một dòng",
    addMeetingParticipantSuccessful: "Thêm người tham gia thành công",

    reportNumMeeting: "Báo cáo số lượng phiên họp",

    emailSubject: "Tiêu đề",
    emailContent: "Nội dung",
    sendSms: "Gửi SMS",
    sendEmail: "Gửi email",
    sendEmailAndSms: "Gửi email & SMS",
    sendEmailSuccessful: "Gửi email thành công",
    sendSmsSuccessful: "Gửi SMS thành công",
    tableView: "Bảng",
    chartView: "Biểu đồ",
    saleArea: "Khu vực",
    saleArea1: "Khu vực (địa bàn)",
    createSaleAccountSuccessful: "Tạo tài khoản TTKD T/TP thành công",
    numberDaysKeepLog: "Số ngày lưu giữ nhật ký",
    accountInfo: "Thông tin tài khoản",
    saleArea2: "Khu vực kinh doanh",
    accountId: "ID tài khoản",
    domain: "Tên miền",
    updatePersonalInfo: "Cập nhật thông tin cá nhân",
    customerInfo: "Thông tin khách hàng",
    updateCustomerInfo: "Cập nhật thông tin khách hàng",
    customerId: "Mã khách hàng",
    customerIdShort: "Mã KH",
    customerName: "Tên khách hàng",
    customerNameShort: "Tên KH",
    customerType: "Loại khách hàng",
    taxCode: "Mã số thuế",
    invalidTaxCode: "Mã số thuế không hợp lệ",
    documentType: "Loại giấy tờ",
    documentNumber: "Số giấy tờ",
    documentNumberInvalid: "Số giấy tờ không hợp lệ",
    issueDate: "Ngày cấp",
    pleaseEnterDocumentIssueDate: "Vui lòng nhập ngày cấp giấy tờ",
    pleaseEnterDocumentExpDate: "Vui lòng nhập ngày hết hạn giấy tờ",
    issuePlace: "Nơi cấp",
    registerServiceInfo: "Thông tin dịch vụ đăng ký",
    displayActiveSubPrice: "{price} VND / {months} tháng",
    displayActiveSubMeetingCount: "{count} cuộc họp / tháng",
    displayActiveSubConcurrentMeetings: "{count} cuộc họp đồng thời",
    displayActiveSubMaxParticipants: "{count} người / cuộc họp",
    displayActiveSubMaxMeetingLength: "{count} phút thời lượng / cuộc họp",
    subCreatedDate: "Ngày đăng ký",
    start: "Bắt đầu",
    startDate: "Ngày bắt đầu",
    endDate: "Ngày kết thúc",
    noActiveSub: "Bạn không có gói cước nào đang sử dụng",
    storageInfo: "Thông tin lưu trữ",
    displayStorageUsed: "Đã sử dụng {used} MB trên tổng số {total} MB",
    personal: "Cá nhân",
    business: "Doanh nghiệp",
    customerTypePersonal: "Cá nhân",
    customerTypeBusiness: "Doanh nghiệp",
    customerStatusActive: "Hoạt động",
    customerStatusInactive: "Tạm ngưng",
    customerStatusCancelled: "Đã huỷ",
    serviceAdminAccountList: "Danh sách tài khoản quản trị dịch vụ",
    reload: "Tải lại",
    createNew: "Tạo mới",
    contactSearchPlaceholder: "Tìm theo tên, email, SĐT",
    adminSearchPlaceholder: "Tìm theo tên, email, SĐT",
    resultCount: "Có {count} kết quả",
    update: "Cập nhật",
    updateInfo: "Cập nhật thông tin",
    actionDelete: "Xoá",
    createServiceAdminAccount: "Tạo tài khoản quản trị dịch vụ",
    updateAdminAccount: "Cập nhật thông tin tài khoản",
    deleteAccount: "Xóa tài khoản",
    updateAccountInfo: "Cập nhật thông tin tài khoản",
    resetAdminAccountPassword: "Đặt lại mật khẩu tài khoản QTDV",
    creator: "Người tạo",
    createdDate: "Ngày tạo",
    unlockAccountSuccess: "Mở khoá tài khoản thành công",
    unlockAccountConfirmation: 'Bạn có chắc mở khoá tài khoản "{account}"?',
    deleteAccountConfirmation: 'Bạn có chắc chắn muốn xoá tài khoản "{account}"?',
    deleteCustomerConfirmation: 'Bạn có chắc chắn muốn xoá khách hàng "{name}"?',
    deleteAccountSuccess: "Xoá tài khoản thành công",
    deleteAllViewerSuccess: "Xóa tất cả tài khoản người xem thành công",
    deleteCustomerSuccess: "Xoá khách hàng thành công",
    deleteYourAccount: "Bạn có chắc chắn muốn xóa tài khoản của mình ?",

    withDrawCustomerConfirmation: 'Rút lại sự đồng ý hệ thống sẽ xoá tài khoản và ngừng sử dụng dịch vụ VNPT GoMeet của khách hàng "{name}". Bạn có chắc chắn muốn thực hiện hành động này không?',
    restrictCustomerConfirmation: 'Hạn chế/phản đối sử dụng dữ liệu cá nhân hệ thống sẽ xoá tài khoản và ngừng sử dụng dịch vụ VNPT GoMeet của khách hàng "{name}". Bạn có chắc chắn muốn thực hiện hành động này không?',

    yes: "Có",
    no: "Không",
    ok: "Đồng ý",
    cancel: "Hủy bỏ",
    success: "Thành công",
    unsuccess: "Không thành công",

    configBackupPolicy: "Thiết lập sao lưu dự phòng",
    backupCronSchedule: "Lịch sao lưu",
    cronScheduleExplain: "Định dạng: giây, phút, giờ, ngày, tháng, năm. Ví dụ: 0 1 1 * * ? (Sao lưu hàng ngày lúc 01:01:00)",
    activateBackupSchedule: "Kích hoạt lịch sao lưu",
    backupLocalPath: "Đường dẫn sao lưu",
    backupSourceCode: "Sao lưu mã nguồn",
    backupDb: "Sao lưu csdl",
    backupOptions: "Tùy chọn lưu trữ",
    storeLocal: "Lưu trữ trên local",
    storeViaFtp: "Lưu trữ thông qua FTP",
    storeBothLocalAndFtp: "Lưu trữ cả local và FTP",
    activeSuccessful: "Kích hoạt thành công",
    saveSettingsSuccessful: "Lưu cài đặt thành công",
    ipBlockList: "Danh sách chặn IP",
    addIpBlock: "Thêm IP chặn",
    itemsPerPage: "dòng / trang",
    deleteIpBlockConfirm: "Bạn có chắc chắn muốn xoá? (ID: {id}, IP: {ip})?",
    deleteIpBlockSuccess: "Xoá IP thành công",
    configPasswordPolicy: "Cài đặt chính sách mật khẩu",
    passwordMinLength: "Chiều dài tối thiểu của mật khẩu",
    passwordMaxLength: "Chiều dài tối đa của mật khẩu",
    passwordPattern: "Biểu thức xác thực mật khẩu",
    passwordDescription: "Mô tả mật khẩu",
    passwordValidationFailedMessage: "Thông báo xác thực mật khẩu không thành công",
    passwordValidityPeriod: "Số ngày hiệu lực của mật khẩu",
    wrongPasswordAttempt: "Số lần được phép nhập mật khẩu sai",
    passwordLockedOut: "Khoá tài khoản sau khi đăng nhập thất bại",
    passwordLockedOutDuration: "Khoá tài khoản sau bao nhiêu phút",
    mustChangeDefaultPassword: "Phải thay đổi mật khẩu mặc định",
    invalidPasswordPattern: "Biểu thức xác thực mật khẩu không đúng",
    appList: "Danh sách ứng dụng",
    countPackage: "Và {count} gói cước",
    editInfo: "Sửa thông tin",
    edit: "Sửa",
    deleteRecordConfirmation: "Bạn có chắc chắn muốn xoá {name}? (ID: {id})?",
    deleteRecordConfirmation2: `Bạn có chắc chắn muốn xoá "{name}"? (ID: {id})?`,
    deleteSuccessful: "Xoá thành công",

    loginPageTitle: "Đăng nhập hệ thống",
    loginVnptSso: "Đăng nhập nội bộ VNPT",
    stayLoggedIn: "Ghi nhớ đăng nhập",
    forgotPasswordQMark: "Quên mật khẩu?",
    registerAccount: "Đăng ký tài khoản",
    registerAccountSubtitle: "Tạo cuộc họp và trò chuyện trực tuyến miễn phí",
    alreadyHaveAccountQ: "Đã có tài khoản?",

    calendar: "Lịch tuần",
    createEvent: "Tạo lịch",
    thisWeek: "Tuần này",
    date: "Ngày",
    datetime: "Thời gian",
    content: "Nội dung",
    location: "Địa điểm",
    noEvent: "Không có lịch họp",
    chairman: "Chủ trì",
    eventPreparation: "Chuẩn bị",
    eventParticipants: "Thành phần",
    eventInvitees: "Mời",
    eventStatusPending: "Chưa được duyệt",
    eventStatusCancelled: "Đã huỷ",
    deleteEventConfirm: `Bạn có chắc chắn muốn xoá lịch "{subject}"?`,
    deleteEventSuccessful: "Xoá lịch thành công",
    editEvent: "Chỉnh sửa lịch",
    eventStartTime: "Giờ bắt đầu",
    eventEndTime: "Giờ kết thúc",
    eventAllDay: "Xảy ra cả ngày",

    unitTime: "Đơn vị",

    deleteAllViewer: "Xóa tất cả người xem",
    deleteAllViewerConfirmation: "Bạn có chắc chắn muốn xóa tất cả người xem ?",

    contactList: "Danh sách liên lạc",
    importContactFromFile: "Nhập danh bạ từ file",
    importUserFromFile: "Nhập tài khoản người dùng từ file",
    addNewContact: "Thêm liên hệ mới",
    updateContact: "Cập nhật liên hệ",
    faceImage: "Hình ảnh khuôn mặt",

    deleteContactSuccessful: "Xoá liên hệ thành công",
    overview: "Tổng quan",
    deleteCustomer: "Xoá khách hàng",
    restrictCustomer: "Hạn chế/phản đối",
    withdrawConsent: "Rút lại đồng ý",
    storageGb: "Dung lượng (GB)",
    storageCapacity: "Dung lượng lưu trữ",
    advancedConfiguration: "Cấu hình nâng cao",
    faceIdConfig: "Tính năng nhận diện khuôn mặt",
    voiceTextConfig: "Tính năng chuyển giọng nói thành văn bản",
    storageFullAlert: "Đã sử dụng hết dung lượng lưu trữ ({used} / {total} MB)",
    adminAccountList: "Danh sách tài khoản quản trị",
    createAdminAccount: "Tạo tài khoản quản trị",
    role: "Vai trò",
    roleAdmin: "Quản trị",
    roleUser: "Người dùng",
    sendServiceRenewReminderEmail: "Gửi email nhắc nhở gia hạn",
    noRegisteredService: "Chưa có dịch vụ được đăng ký",
    serviceRegisterHistory: "Lịch sử đăng ký gói cước",
    storageHistory: "Gói cước lưu trữ",
    sendServiceRenewReminderEmailConfirm: "Gửi email nhắc nhở gia hạn?",
    sendServiceRenewReminderEmailSuccessful: "Gửi email thông báo gia hạn thành công",

    meetingShareCamera: "Chia sẻ camera",
    meetingTurnOffCamera: "Tắt Camera",
    meetingMuteOnStart: "Tắt tiếng khi tham gia",
    meetingChatNotAllow: "Không cho phép trò chuyện",
    meetingStatusPending: "Đang chờ",
    meetingStatusInProgress: "Đang diễn ra",
    meetingStatusEnded: "Đã kết thúc",
    meetingStatusCancelled: "Đã huỷ",
    meetingName: "Tên cuộc họp",
    meetingPrivateChatAllow: "Cho phép trò chuyện riêng tư",
    meetingPublicChatAllow: "Cho phép trò chuyện công khai",

    createNewCustomer: "Tạo khách hàng mới",
    createCustomer: "Tạo khách hàng",
    createNewCustomerSuccessful: "Tạo khách hàng mới thành công",
    customerList: "Danh sách khách hàng",
    areaFilterSelectLabel: "KH thuộc TTKD",
    subscriptionStatusFilterSelectLabel: "Thời hạn",
    planExpireGt2Months: "Còn hạn trên 2 tháng",
    planExpireLt2Months: "Còn hạn dưới 2 tháng",
    nearExpired: "Sắp hết hạn",
    unexpired: "Còn hiệu lực",
    expired: "Đã hết hạn",

    decree: "Nghị định",
    createDate: "Ngày tạo",
    deleteDate: "Ngày xóa",

    verificationEmailSent: "Gửi email xác nhận thành công",
    verificationEmailSentSubtitle: "Chúng tôi đã gửi một email đến {email}.\nNhấp vào liên kết xác nhận trong email đó để bắt đầu sử dụng VNPT Gomeet.",
    notGetVerificationEmailYetC: "Nếu chưa nhận được email,",
    resendVerificationEmail: "Gửi lại email xác nhận",
    openGmail: "Mở Gmail",
    openOutlook: "Mở Outlook",
    welcomeMsg: "Chào mừng bạn đến với VNPT Gomeet",
    welcomeMsgSubtitle: "Vui lòng điền các thông tin sau đây để hoàn tất đăng ký tài khoản",
    signupSuccessful: "Đăng ký thành công",
    signupSuccessfulSubtitle: "Bạn đã thực hiện đăng ký thành công tài khoản, vui lòng đăng nhập vào hệ thống để trải nghiệm dịch vụ.",
    invalidSecretKey: "Mã bí mật không hợp lệ, vui lòng thử lại.",
    cannotLeaveFieldBlank: "Không được bỏ trống trường này",

    maxParticipant: "SL tham dự lớn nhất",

    createMeeting: "Tạo cuộc họp",
    startNewMeeting: "Bắt đầu cuộc họp nhanh",
    joinMeeting: "Tham gia",
    endMeeting: "Kết thúc",
    meetingTableActualDateTimeTitleAttr: "Bắt đầu: {start}\nKết thúc: {end}",
    meetingTableScheduledDateTimeTitleAttr: "Bắt đầu (dự kiến): {start}\nKết thúc (dự kiến): {end}",
    startMeetingWarning: "Vui lòng không đóng trình duyệt khi chưa có người tham dự",
    endMeetingWarning: "Kết thúc cuộc họp {name} (ID: {id})?",
    endThisMeetingWarning: "Kết thúc cuộc họp này?",
    pleaseSelectValidDate: "Vui lòng chọn ngày hợp lệ",
    meetingDuration: "Thời lượng",
    meetingDurationFormFeedback: "Thời lượng tối thiểu 15 phút, tối đa",
    accessCode: "Mã truy cập",
    enterAccessCode: "Nhập mã truy cập",
    accessCodeFormFeedback: "Độ dài 6-12 ký tự, chỉ dùng số hoặc chữ không dấu",
    createRandomAccessCode: "Tạo ngẫu nhiên",
    accessPermission: "Quyền truy cập",
    meetingOperator: "Người điều hành",
    meetingOperatorBadge: "Điều hành",
    deleteMeeting: "Xoá cuộc họp",
    meetingParticipantsList: "Danh sách người tham dự",
    meetingParticipantsMaxCount: "Tối đa {count} người",
    maxMeetingParticipantsExceeded: "Vượt quá số người tham gia tối đa!",
    meetingConfig: "Thiết lập cuộc họp",
    selectedWithCount: "Đã chọn ({count})",

    QRCodeText: "Mã QR tham gia",
    copieQRLink: "Sao chép link họp",
    download: "Tải xuống",

    privateSub1: "Thông tin cuộc họp sẽ được gửi riêng cho những người có trong danh sách, chỉ có những người này mới được phép tham gia vào cuộc họp.",
    faceIdSub: "Chỉ những người có thông tin hình ảnh khuôn mặt mới được thêm vào cuộc họp",
    faceIdIconSub: "Đã có hình ảnh nhận diện khuôn mặt",
    warningIdIconSub: "Chưa có hình ảnh nhận diện khuôn mặt. Vào Danh bạ để cập nhật ảnh khuôn mặt cho người này!",

    onlyShowCameraForOperator: "Chỉ hiển thị webcam cho người trình bày",
    enableToggleMeetingRecording: "Cho phép bật/tắt ghi âm cuộc họp",
    enableAutomaticMeetingRecording: "Tự động bật ghi âm cuộc họp",
    enableVoiceText: "Bật chuyển giọng nói thành văn bản",
    enableMicro: "Cho phép sử dụng Micro",
    enableTakingNote: "Bật tính năng ghi chú",
    enableParticipationBeforeHost: "Cho phép tham gia trước người chủ trì",

    chooseContact: "Chọn liên hệ",
    meetingTypeClosed: "Cuộc họp riêng tư",
    meetingTypeOpen: "Cuộc họp công khai",

    private: "Riêng tư",
    public: "Công khai",

    joinByFaceId: "Tham gia bằng nhận diện khuôn mặt",

    pleaseSelectMeetingStartDate: "Vui lòng chọn ngày bắt đầu cuộc họp",
    pleaseSelectMeetingStartDatetime: "Vui lòng chọn ngày giờ bắt đầu cuộc họp",
    invalidMeetingStartDatetime: "Thời điểm bắt đầu cuộc họp không hợp lệ",
    invalidMeetingOperatorOrParticipantEmail: "Email người điều hành hoặc người tham dự không hợp lệ",
    invalidMeetingDurationOrExceededLimit: "Thời lượng cuộc họp không hợp lệ hoặc vượt quá giới hạn cho phép",
    createMeetingSuccessful: "Tạo cuộc họp thành công",
    editMeeting: "Chỉnh sửa cuộc họp",

    namePlaceHolder: "Nhập vào họ và tên",
    emailPlaceHolder: "Nhập vào email",
    phonePlaceHolder: "Nhập vào số điện thoại",

    newMeetingDefaultName: "Cuộc họp ngày ",

    openInApp: "Mở trong ứng dụng",
    downloadApp: "Tải ứng dụng",
    meetingEndedMsg: "Phiên họp đã kết thúc",
    meetingRestartMsg: "Bạn có thể bắt đầu lại cuộc họp",
    meetingDetails: "Chi tiết cuộc họp",
    customerUserAccountList: "Danh sách tài khoản người dùng",
    createCustomerUserAccount: "Tạo tài khoản người dùng",
    updateCustomerInfoSuccessful: "Cập nhật thông tin khách hàng thành công",
    exportParticipants:"Xuất người tham gia",
    exportContentRoom:"Nội dung cuộc họp",

    meetingPendingMsg: "Cuộc họp chưa bắt đầu",

    createSubPlan: "Tạo gói cước",
    updateSubPlan: "Chỉnh sửa gói cước",
    subPlanName: "Tên gói cước",
    subPlanCode: "Mã gói cước",
    activeStatus: "Trạng thái kích hoạt",
    updateSubPlanSuccessful: "Chỉnh sửa gói cước thành công",
    createSubPlanSuccessful: "Tạo gói cước thành công",
    saleAccountList: "Danh sách tài khoản TTKD T/TP",
    createSaleAccount: "Tạo tài khoản TTKD T/TP",
    subPlanList: "Danh sách gói cước",

    updateApiConfig: "Chỉnh sửa hạ tầng",
    newApiConfig: "Tạo mới hạ tầng",
    createApiConfigSuccessful: "Tạo hạ tầng thành công",
    updateApiConfigSuccessful: "Chỉnh sửa hạ tầng thành công",

    onOff: "Bật/Tắt",
    deleteAll: "Xóa tất cả",
    deleteAllContactsConfirm: "Bạn có muốn xóa tất cả danh bạ",

    meetingId: "Mã cuộc họp",
    viewMeetingRecordedFile: "Xem file ghi âm",
    meetingNoRecordedFile: "Chưa có file ghi âm",
    cancelMeeting: "Huỷ cuộc họp",
    meetingDate: "Ngày họp",
    meetingScheduledTime: "Thời gian (dự kiến)",
    meetingActualTime: "Thời gian (thực tế)",
    numOfParticipants: "Số người tham gia tối đa",
    hostJoinUrl: "Link chủ trì",
    participantJoinUrl: "Link truy cập",
    copyJoinUrl: "Sao chép link truy cập",
    TypeForm: "Hình thức họp",

    meetingParticipantsJoined: "Đang tham gia ({count})",
    meetingParticipantsNotJoined: "Chưa tham gia ({count})",

    sendEmailInvitation: "Gửi email mời",
    sendEmailInvitation2: "Gửi email mời tham gia",
    sendEmailInvitationConfirm: "Gửi email mời tham gia?",
    sendEmailInvitationConfirm2: "Gửi email mời tham gia đến {email}?",
    sendEmailInvitationToAll: "Gửi email mời đến tất cả những người tham gia",
    sendEmailInvitationSuccessful: "Gửi email mời tham gia thành công",
    notSendEmailInvitation: "Chưa gửi email mời tham gia",
    alreadySentEmailInvitation: "Đã gửi email mời tham gia",

    sendMeetingUpdateEmail: "Gửi email thay đổi lịch họp",
    sendMeetingUpdateEmailToAll: "Gửi email thay đổi lịch họp đến tất cả những người tham gia",
    sendMeetingUpdateEmailSuccessful: "Gửi email thay đổi lịch họp thành công",
    notSendMeetingUpdateEmail: "Chưa gửi email thay đổi lịch họp",
    alreadySentMeetingUpdateEmail: "Đã gửi email thay đổi lịch họp",

    sendMeetingCancelEmail: "Gửi email báo huỷ lịch họp",
    sendMeetingCancelEmailToAll: "Gửi email báo huỷ lịch họp đến tất cả những người tham gia",
    sendMeetingCancelEmailSuccessful: "Gửi email báo huỷ lịch họp thành công",
    notSendMeetingCancelEmail: "Chưa gửi email báo huỷ lịch họp",
    alreadySentMeetingCancelEmail: "Đã gửi email báo huỷ lịch họp",

    sendSmsInvitation: "Gửi SMS mời",
    sendSmsInvitation2: "Gửi SMS mời tham gia",
    sendSmsInvitationConfirm: "Gửi SMS mời tham gia đến số điện thoại {phone}?",
    sendSmsInvitationSuccessful: "Đã gửi SMS mời tham gia đến số điện thoại {phone}",

    updateMeetingParticipant: "Cập nhật thông tin người tham gia",
    copiedHostJoinUrl: "Sao chép link chủ trì thành công",
    copied: "Sao chép thành công",
    faceidStatus: "Bật/tắt FaceID",

    numMeeting: "Số cuộc họp",

    cancelThisMeetingConfirm: "Bạn có chắc chắn muốn huỷ cuộc họp này?",
    cancelMeetingSuccessful: "Huỷ cuộc họp thành công",
    deleteThisMeetingConfirm: "Bạn có chắc chắn muốn xoá cuộc họp này?",
    deleteMeetingSuccessful: "Xoá cuộc họp thành công",

    coreImplName: "Nền tảng sử dụng",
    activeSubPlans: "Đang sử dụng",
    inactiveSubPlans: "Đã vô hiệu hoá",
    deleteSubPlanConfirm: "Bạn có chắc chắn muốn xoá gói cước {name} (ID: {id})?",
    deleteSubPlanSuccessful: "Xoá gói cước thành công",

    logPolicy: "Chính sách log",
    deleteLogConfirm: "Bạn có chắc chắn muốn xoá? (ID: {id})",
    deleteLogSuccessful: "Xoá log thành công",

    totalCustomers: "Tổng số khách hàng",
    totalMeetings: "Tổng số phòng họp được tạo",
    totalPackages: "Tổng số gói cước được tạo",
    totalCustomerAccounts: "Tổng số tài khoản được tạo",
    totalInprogressMeetings: "Tổng số cuộc họp đang diễn ra",
    totalPendingMeetings: "Tổng số cuộc họp sắp diễn ra",
    totalEndedMeetings: "Tổng số cuộc họp đã kết thúc",
    totalCancelledMeetings: "Tổng số cuộc họp bị huỷ",
    totalMeeting: "Tổng số cuộc họp",

    dashboardChartTitle: "TỔNG SỐ CUỘC HỌP, NGƯỜI THAM GIA & CAMERA BẬT",
    fromDate: "Từ ngày",
    toDate: "Đến ngày",
    apply: "Áp dụng",
    invalidDateRange: "Khoảng thời gian đã chọn không hợp lệ",
    meetingsListToday: "Danh sách các cuộc họp diễn ra hôm nay",
    viewStats: "Xem thống kê",
    numCameraOn: "Camera bật",
    numVoiceOn: "Mic bật",

    emailTypeInviteMeeting: "Mời tham gia",
    emailTypeUpdateMeeting: "Thay đổi lịch họp",
    emailTypeCancelMeeting: "Huỷ lịch họp",

    contentCannotBeBlank: "Nội dung không được bỏ trống",
    updateEmailTemplateSuccessful: "Cập nhật mẫu email thành công",
    openInBrowser: "Mở trên Web",
    packageType: "Loại gói cước",
    demo: "Demo",
    trial: "Dùng thử",
    testing: "Thử nghiệm",
    official: "Chính thức",
    meetingHasRecording: "Cuộc họp được ghi âm",
    contactFileFormatError: "Vui lòng tải lên file có định dạng excel và cấu trúc bảng giống file mẫu",
    contactFileSizeError: "Không thể gửi tệp có kích thước lớn hơn 1MB",
    passwordhasbeenusedbefore: "Mật khẩu mới không được trùng với mật khẩu hiện tại",
    selectRangeDate: "Từ ngày - Đến ngày",
    export: "Xuất Excel",
    noFoundSearch: "Không tìm thấy kết quả nào.",

    SigninCas_Ticket_Require: "Ticket là bắt buộc nhập",
    SigninCas_Service_Require: "Service là bắt buộc nhập",
    UsernameRequired: "Tên đăng nhập là bắt buộc nhập",
    PasswordRequired: "Mật khẩu là bắt buộc nhập",
    UsernameMaxLength: "Tên đăng nhập tối đa 32 ký tự",
    PasswordMaxLength: "Mật khẩu tối đa 32 ký tự",
    InvalidLogin: "Tên đăng nhập hoặc mật khẩu không đúng",
    LoginLockoutEnabled: "Tài khoản sẽ tạm khoá {m} phút sau {i} lần đăng nhập thất bại.",
    LockAccountEnabled: "Bạn đăng nhập thất bại 5 lần, tài khoản của bạn sẽ tạm khoá đến {m}",
    InvalidCas: "Thông tin truy cập không hợp lệ",
    UserNotFound: "Không tìm thấy thông tin tài khoản",
    PageRequired: "Page là bắt buộc nhập",
    PageRangeInteger: "Page trong khoảng từ 1 - 214748364",
    PageSizeRequired: "PageSize là bắt buộc nhập",
    PageSizeRange: "PageSize trong khoảng 10 - 1000",
    ConfirmPasswordRequired: "Vui lòng nhập xác nhận mật khẩu",
    PasswordNotMatch: "Xác nhận mật khẩu không đúng",
    PasswordLength: "Mật khẩu tối thiểu 6 ký tự và tối đa 32 ký tự",
    UsernameDuplicate: "Trùng tên đăng nhập",
    AreaRequired: "Khu vực là bắt buộc nhập",
    BadRequest: "Có lỗi xảy ra",
    EmailRequired: "Email là bắt buộc",
    PasswordPolicyLength: "Chiều dài mật khẩu từ 6 - 16 ký tự",
    PasswordPolicyRegex: "Mật khẩu tối thiểu 8 ký tự bao gồm ký tự số, chữ thường, chữ in hoa và ký tự đặc biệt.",
    ActivationCodeExpired: "Mã kích hoạt tài khoản đã hết hiệu lực",
    EmailExist: "Địa chỉ email đã được sử dụng",
    InvalidActivationCode: "Mã kích hoạt tài khoản không hợp lệ",
    NameMaxLength: "Độ dài Họ Tên tối đa 100 ký tự",
    PhoneNumberRequired: "Số điện thoại là bắt buộc",
    PhoneMaxLength: "Số điện thoại tối đa 50 ký tự",
    AddressMaxLength: "Địa chỉ tối đa 255 ký tự",
    EmailInvalid: "Địa chỉ Email không hợp lệ",
    EmailMaxLength: "Email tối đa 250 ký tự",
    incorrect_file_format: "Không đúng định dạng file",
    file_not_found: "Không tìm thấy tập tin ",
    IdRequired: "Id là bắt buộc",
    AccessIsDenied: "Truy cập dữ liệu không hợp lệ",
    OldPasswordInvalid: "Mật khẩu hiện tại không đúng",
    NewPasswordInvalid: "Mật khẩu mới trùng mật khẩu hiện tại",
    UnableToDeleteAcc: "Bạn không thể xóa tài khoản này. Tài khoản này đang tham gia vào hệ thống.",
    DeleteAllCustomerUserViewSuccessful: "Xoá thông tin tài khoản thành công",
    InternalServerError: "Có lỗi xảy ra trong quá trình thực hiện",
    InvalidSecretKey: "Mã bí mật không hợp lệ",
    SecretKeyExpired: "Mã bí mật hết hiệu lực",
    UsernameExist: "Tài khoản đã tồn tại",
    InvalidCustomerId: "Không tìm thấy Khách hàng",
    CustomerIsExisting: "Khách hàng này đang tồn tại (Trùng Mã số thuế hoặc số của các loại giấy tờ khác)",
    CustomerDuplicateIdCode: "Trùng số giấy tờ",
    CustomerDuplicateTaxCode: "Trùng mã số thuế",
    CustomerDuplicateCode: "Trùng mã khách hàng",
    CustomerDuplicatePhoneNumber: "Trùng số điện thoại",
    CustomerNameIsRequired: "Họ Tên không được bỏ trống",
    CustomerNameMaxLength: "Độ dài Họ Tên tối đa 255 ký tự ",
    PhoneNumberMinLength: "Độ dài Số Điện Thoại ít nhất 10 ký tự số",
    AreaIdIsRequired: "ID Tỉnh Thành bắt buộc ",
    AppNameRequired: "Tên ứng dụng là bắt buộc",
    AppDomainNameRequired: "Tên domain là bắt buộc ",
    AppLogoRequired: "Logo là bắt buộc ",
    AppLogoExtRequired: "Loại file là bắt buộc",
    AppActiveRequired: "Trạng thái là bắt buộc",
    InvalidLogo: "Ảnh Logo không hợp lệ. Chỉ cho phép ảnh có định dạng .jpg, .jpeg, .png",
    AppNameCustomerExist: "Khách hàng đã được chọn để tạo ứng dụng",
    AppNameNotFound: "Không tìm thấy ứng dụng",
    InvalidAreaId: "Khu vực không hợp lệ",
    UnableToDelete: "Không thể xoá dữ liệu ràng buộc",
    InvalidContactId: "Không tìm thấy thông tin danh bạ",
    InvalidContactCode: "Mã Code NULL hoặc không hợp lệ",
    ContactNameIsRequired: "Họ Tên là bắt buộc",
    ContactNameMaxLength: "Độ dài Họ Tên tối đa 255 ký tự ",
    UnauthorizeEditContact: "Bạn không thể cập nhật thông tin Người tham gia không phải do Bạn tạo",
    ImportContactSuccessful: "Import danh bạ thành công",
    InvalidParamInput: "Dữ liệu đầu vào bị NULL hoặc không hợp lệ",
    InvalidCustomerSubscriptionId: "Không tìm thấy thông tin của khách hàng đăng ký gói cước",
    CustomerIdIsRequired: "ID Khách hàng bắt buộc nhập",
    SubscriptionPlanIdIsRequired: "ID Gói cước bắt buộc nhập",
    StartTimeIsRequired: "Ngày bắt đầu sử dụng bắt buộc nhập",
    NumberOfConcurrentMeetings: "Số lượng cuộc họp đồng thời phải trong khoảng 1: 100",
    InvalidViewModel: "ViewModel không hợp lệ",
    InvalidCustomer: "Khách hàng không hợp lệ hoặc không tồn tại",
    InvalidSubscriptionPlan: "Gói cước không hợp lệ hoặc không tồn tại",
    CusSubsPlanToRenewIsNotFound: "Không tìm thấy gói cước của khách hàng cần nâng cấp",
    CustomerNotMatchForRenewOrUpgrade: "Khách hàng cần nâng cấp hoặc gia hạn không khớp với khách hàng đăng ký dịch vụ của gói cần nâng cấp hoặc gia hạn",
    SubjectRequired: "Tiêu đề không được bỏ trống",
    SubjectMaxLength: "Độ dài Tiêu đề tối đa 255 ký tự ",
    ContentRequired: "Nội dung không được bỏ trống",
    ModelNotFound: "Không tìm thấy thông tin",
    IPAddressIsRequired: "Địa chỉ Ip là bắt buộc",
    IPAddressNULL: "Địa chỉ IP không được null",
    InvalidIPAddress: "Không đúng cấu hình IP ",
    MeetingSecretKeyRequired: "SecretKey là bắt buộc",
    MeetingNotFound: "Mã phòng họp không tồn tại hoặc đã bị xóa",
    AccessCodeRequired: "AccessCode là bắt buộc ",
    FullNameRequired: "FullName là bắt buộc",
    InvalidAccessCode: "Mã truy cập không đúng",
    MeetingStatusPending: "Phiên họp chưa bắt đầu",
    MeetingStatusEnded: "Phiên họp đã kết thúc",
    StartMeetingExceed: "Số lượng cuộc họp đồng thời vượt quá số lượng cho phép của gói đăng ký.",
    NotAllowedToJoinMeeting: "Phòng họp đã đạt tối đa số lượng người tham dự",
    MeetingNameIsRequired: "Tiêu đề lịch họp là bắt buộc ",
    ScheduleStartTimeIsRequired: "Thời gian bắt đầu cuộc họp bắt buộc nhập.",
    ScheduleDurationIsRequired: "Khoảng thời gian diễn ra buổi họp bắt buộc nhập",
    MinScheduleDuration: "Khoảng thời gian diễn ra tối thiểu là 15 phút",
    AccessCodeIsRequired: "Mã truy cập bắt buộc",
    AccessCodeLength: "Mã truy cập tối thiểu 6 ký tự và tối đa 12 ký tự",
    ParticipantRequired: "Vui lòng nhập thông tin người điều hành và tham dự",
    CustomerSubscriptionNotFound: "Khách hàng chưa đăng ký gói cước sử dụng",
    CustomerSubscriptionIsExpired: "Gói cước đã hết hạn vui lòng liên hệ nhân viên bán hàng để gia hạn dịch vụ",
    MeetingCountDailyIsExceeded: "Cuộc họp hiện tại vượt quá số lượng cho phép của gói đăng ký",
    NumberOfParticipantIsExceeded: "Số lượng người tham gia vượt quá số lượng cho phép",
    MinimumNumOfParticipants: "Số người tham gia cuộc họp phải ít nhất 1 người",
    InvalidMeetingStatus: "Trạng thái cuộc họp không hợp lệ. Trạng thái cuộc hợp gồm : Chờ (pending), Đang thực hiện (inprogress), Kết thúc (end)",
    OnlyDelMeetingInPendingStatus: "Không thể xoá cuộc họp đang diễn ra",
    MeetingIdIsRequired: "meetingId là bắt buộc",
    InvalidMeetingId: "Không tìm thấy cuộc họp",
    InvalidRequest: "Yêu cầu không hợp lệ",
    TemplateNotFound: "Không tìm thấy mẫu email",
    ParticipantNameIsRequired: "Họ tên người tham gia là bắt buộc ",
    ParticipanNameMaxLength: "Độ dài Họ Tên tối đa 255 ký tự ",
    InvalidMeetingRole: "Vai trò người tham gia cuộc họp không hợp lệ. Vai trò gồm : tham gia (PARTICIPANT), người điều hành (OPERATOR)",
    MeetingAccessDenied: "Bạn không có quyền thao tác phiên họp này",
    PasswordValidityPeriod: "Số ngày hiệu lực của mật khẩu trong khoảng 1 - 3650 ngày",
    WrongPasswordAttempt: "Số lần được phép nhập mật khẩu sai trong khoảng 1 - 100 lần",
    LockedOutDuration: "Thời gian khoá tài khoản trong khoảng 1 - 1440 phút",
    PasswordPolicyInvalid: "Chiều dài tối đa mật khẩu phải lớn hơn chiều dài tối thiểu",
    LocalPathIsRequired: "Đường dẫn lưu trữ không được để trống",
    LocalPathInvalid: "Đường dẫn sao lưu không hợp lệ.",
    ConfigFtpHostInvalid: "Thông tin cấu hình FTP không hợp lệ",
    BackupPolicyBadRequest: "Lịch sao lưu không hợp lệ. Cú pháp: giây phút giờ ngày tháng năm. Ví dụ: 5 1 9 4 *  ?",
    ConfigBackupPolicyInvalid: "Thông tin cấu hình sao lưu không hợp lệ",
    PortLength: "Port trong phạm vi 0-65535",
    PortPolicyError: "Thay đổi port không thành công",
    ConfigIsActive: "Phải inactive cấu hình trước khi xoá",
    SubcriptionPlanNameRequired: "Tên gói cước là bắt buộc",
    SubcriptionPlanNameMaxLength: "Tên gói cước tối đa 255 ký tự",
    SubcriptionPlanPackageTypeIsRequired: "PackageType là bắt buộc",
    MaximumNumberOfParticipantsIsRequired: "Số người tối đa tham gia một buổi họp là bắt buộc",
    MaximumNumberOfParticipantsLengh: "Số người tối đa tham gia từ 1: 1000",
    NumberOfConcurrentMeetingsIsRequired: "Số lượng cuộc họp đồng thời  là bắt buộc",
    NumberOfConcurrentMeetingsLength: "Số lượng cuộc họp đồng thời từ 1: 100",
    MaximumLengthOfOneMeetingIsRequired: "Thời lượng tối đa 1 buổi họp là bắt buộc",
    MaximumLengthOfOneMeetingLength: "Thời lượng tối đa từ 30 - 1440",
    NumberOfMeetingsPerMonthIsRequired: "Số cuộc họp trong một tháng là bắt buộc",
    NumberOfMeetingsPerMonth: "Số cuộc họp trong một tháng từ 1 - 10000",
    NumberOfDaysUsageIsRequired: "Thời gian sử dụng gói cước là bắt buộc",
    NumberOfDaysUsage: "Thời gian sử dụng từ 1 - 36",
    SubcriptionPlanPriceIsRequired: "Đơn giá là bắt buộc",
    CoreImplNameIsRequired: "Sử dụng nền tảng/công nghệ : BBB/Zoom",
    UnableToDeletePackage: "Gói cước đã sử dụng và không thể xoá",
    MeetingStatusInvalid: "Trạng thái phòng họp không đúng",
    ApiKeyNameyIsNull: "ApiKey và ApiKeyName là bắt buộc",
    WebhookConfigurationIsExisting: "Thông tin cấu hình webhookConfiguration đã tồn tại",
    InvalidWebhookConfigureId: "WebhookConfigureId không hợp lệ",
    UpdateSuccess: "Cập nhật thành công",
    TokenInvalid: "Hết phiên làm việc. Vui lòng đăng nhập lại",
    timeEndValid: "Thời gian kết thúc không hợp lệ",
    passwordFormat: "Mật khẩu tối thiểu 8 ký tự bao gồm ký tự số, chữ thường, chữ in hoa và ký tự đặc biệt.",
    UpdateRoleInvalid: "Thông tin Role không hợp lệ, role bắt buộc là 'Customer', 'User', 'View'",
    NewPasswordRequired: "Mật khẩu là bắt buộc",
    InvalidCustomerName: "Họ và tên khách hàng không hợp lệ, Họ và tên chỉ chứa các ký tự alphabet",
    APIURLContactImport: "Nhập URL API danh bạ",
    faceImageTitle1: "Chọn các hình ảnh cho người dùng",
    faceImageTitle2: "Tên hình giống với code tương ứng của người dùng trong danh bạ",
    faceChosePlaceholder: "Có thể chọn nhiều ảnh cùng lúc",
    UrlNotAllowed: "Url không được chấp nhận",
    FormatEmailInvalid: "Email không đúng định dạng",
    FormatInvalidName: "Tên không đúng định dạng",
    FormatPhoneInvalid: "Số điện thoại không đúng định dạng",
    PasswordInWordlist: "Không được sử dụng mật khẩu dễ đoán.",
    widgetDescription: " Widget cho phép mọi người dễ dàng nhúng cửa sổ phòng họp vào trong trang web của họ. Giúp mọi người sử dụng gomeet dễ dàng hơn",
    createWidget: "Tạo Widget",
    createContentWidget: "Đặt đoạn mã này ở bất cứ đâu mà bạn muốn thêm Widget vào",
    attribute: "Thuộc tính",
    required: "Bắt buộc",
    description: "Mô tả",
    Upload_success: "Tải lên hình ảnh thành công",
    Upload_failed: "Tải lên hình ảnh thất bại",
    Upload_failed_code_exist: "Lỗi: Mã code đã tồn tại", 
    InvalidParticipantName: "Lỗi: Tên người tham dự không đúng cú pháp", 
  },
  en: {
    user: "User",
    login: "Login",
    logout: "Logout",
    username: "Username",
    usernameOrEmail: "Username or email",

    signUpIAgreeWith: "I have read and agree with",
    signUpTermOfUse: "Terms of Service",
    and: "and",
    signUpPrivacyPolicy: "Privacy Policy",

    portalHome: "Home Page",
    footerAttribution: "Product of VNPT-IT",
    version: "Version",
    headerMenuAdmin: "Administration",
    serviceAdminAccount: "Service admin accounts",
    saleAccount: "Sale accounts",
    customerAdminAccount: "Customer admin accounts",
    application: "Application",
    subscriptionPlan: "Subscription plan",
    meeting: "Meeting",
    meetingList: "Meetings",
    manageMeetings: "Manage meetings",
    viewOnly: "View only",

    selectAll: "Select all",
    deselectAll: "Deselect all",

    done: "End",
    inprogress: "Inprogress",
    pending: "Waiting",
    cancelled: "Cancelled",

    active: "Active",
    unactive: "Inactive",

    all: "All",
    status: "Status",
    contact: "Contacts",
    chooseFromContacts: "Choose from contacts",
    manageAccount: "Manage account",
    manageServices: "Manage services",
    emailTemplate: "Email template",
    weeklyCalendar: "Weekly calendar",
    weeklyCalendarList: "Weekly calendar list",
    meetingLocation: "Meeting location",
    report: "Reports",
    alert: "Alert",
    details: "Details",
    meetingCount: "Meeting count",
    meetingCountDetails: "Meeting count details",
    meetingCountTotal: "Meeting count total",
    meetingDetailReport: "detailed meeting report",
    settings: "Settings",
    passwordPolicy: "Password policy",
    ipBlacklist: "IP blacklist",
    systemLogs: "System logs",
    backup1: "Backup",
    changeWebPort: "Change web port",
    manageConfigulation: "Configulation management",
    password: "Password",
    currentPassword: "Current password",
    newPassword: "New password",
    confirmPassword: "Confirm password",
    save: "Save",
    copy: "Copy",
    clone: "Clone",
    change: "Change",
    saveChanges: "Save changes",
    note: "Note",
    updateSuccessful: "Updated successful",
    createSuccessful: "Created successful",
    passwordsNotMatch: "Passwords not match",
    changePassword: "Change password",
    resetPassword: "Reset password",
    unlockAccount: "Unlock account",
    forgotPassword: "Forgot password",
    passwordChangedSuccessful: "Password changed successful",
    passwordResetSuccessful: "Password reset successful",
    actionComplete: "Complete",
    fullName: "Full name",
    phoneNumber: "Phone number",
    invalidPhoneFormat: "Invalid phone number format",
    address: "Address",
    companyName: "Company name",
    invalidEmail: "Invalid email",
    account: "Account",
    pleaseChoose: "Please Choose",
    corporations: "Corporations",
    vinaphone: "Vinaphone",
    media: "Media",
    net: "NET",
    vt_ttp: "VT-TTP",
    tdagency: "TD Agency",
    it: "IT",
    other: "Other",
    outside: "Besides VNPT",
    organ: "State Agencies",
    packageStatus: "Package Status",
    invnpt: "In VNPT",
    individual: "Individual",
    enterprise: "Enterprise",
    or: "Or",

    unitTime: "Time unit",

    usernameDescription: "Accept alphanumeric characters and underscores _",
    createAccount: "Create account",
    createAccountSuccessful: "Account created successfully",
    createAdminAccountSuccessful: "Account created successfully",
    customerAdminAccountList: "Customer admin accounts",
    createCustomerAdminAccount: "Create customer admin account",
    createCustomerAdminAccountSuccessful: "Account created successfully",
    createIpPolicySuccessful: "IP policy created successful",

    appName: "App name",
    customer: "Customer",
    customerAutofillPlaceholder: "search by code, name, email or phone number",
    customerSearchPlaceholder: "code, name, email or phone number",
    meetingSearchPlaceholder: "Search by code, customer name",
    meetingDetailReportSearchPlaceholder: "Search by meeting name, creator",
    search: "Search",
    advancefilter: "Advanced filter",
    clearFilter: "Clear",
    keyword: "Keyword",
    createApp: "Create application",
    createAppSuccessful: "Application created successful",
    updateApp: "Update application info",
    updateAppSuccessful: "Application updated successful",
    calendarLocationName: "Location name",
    updateCalendarLocationSuccessful: "Location updated successfully",
    createCalendarLocationSuccessful: "Location created successfully",
    workTitle: "Work title",
    workDepartment: "Department",
    workOrganization: "Organization",
    workOrganizationName: "Organization name",
    downloadSampleFile: "Download sample file",
    importFromFile: "Import from file",
    importContactsFromFileSuccessful: "Imported successful",
    createContactSuccessful: "Contact created successful",
    noData: "No data",
    loadingData: "Loading data...",
    chooseSubscription: "Choose subscription",
    subscriptionInfo: "Subscription info",
    subscriptionLength: "Validity period",
    maximumNumberOfParticipantsInMeeting: "Maximum number of meeting participants",
    numberOfConcurrentMeetings: "Number of concurrent meetings",
    maximumLengthOfOneMeeting: "Maximum length of one meeting",
    numberOfMeetingsPerMonth: "Number of meetings per month",
    serviceInfo: "Service info",
    effDate: "Effective date",
    expDate: "Expiry date",
    selectEffDate: "Select effective date",
    selectExpDate: "Select expiration date",
    currentExpDate: "Current expiry date",
    expDateAfterRenew: "Expiry date after renew",
    servicePrice: "Service price",
    vatTax: "VAT tax",
    amountCustomerToPay: "Customer needs to pay",
    registerConfirmCorrectInfo: "Please confirm the information above is correct",
    renewConfirmCorrectInfo: "Please confirm the information above is correct",
    upgradeConfirmCorrectInfo: "Please confirm the information above is correct",
    renewService: "Renew service",
    cancelService: "Cancel service",
    renewServiceSuccess: "Renewed successfully",
    cancelServiceSuccess: "Cancelled successfully",
    subscriptionToRegister: "Subscription to register",
    serviceStartDate: "Service start date",

    cancelServiceConfirm: "Are you sure you want to cancel the service?",

    hours: "Hours",
    minutes: "Minutes",
    days: "Days",
    weeks: "Weeks",
    months: "Months",
    years: "Years",
    maximum: "Maximum",
    register: "Register",

    agree: "Agree",
    disagree: "Disagree",

    registerService: "Register service",
    registerServiceSuccessful: "Register service successful",
    subscriptionToUpgradeTo: "Subscription to upgrade to",
    upgradeOption: "Change service option",
    upgradeOption0: "Keep the current billing period",
    upgradeOption1: "Extend the current billing period",
    upgradeDurationExtension: "Extension duration",
    upgradeService: "Change service",
    upgradeServiceSuccessful: "Changed service successful",
    meetingParticipant: "Meeting participant",
    addMeetingParticipant: "Add meeting participant",
    addMeetingParticipantSuccessful: "Added meeting participant successful",

    reportNumMeeting: "Report the number of meeting",

    emailSubject: "Subject",
    emailContent: "Content",
    sendSms: "Send SMS",
    sendEmail: "Send email",
    sendEmailAndSms: "Send email and SMS",
    sendEmailSuccessful: "Sent email successfully",
    sendSmsSuccessful: "Sent SMS successfully",
    tableView: "Table view",
    chartView: "Chart view",
    saleArea: "Sale area",
    saleArea1: "Sale area",
    createSaleAccountSuccessful: "Created sale account successfully",
    numberDaysKeepLog: "Days to keep log",
    accountInfo: "Account info",
    saleArea2: "Sale area",
    accountId: "Account ID",
    domain: "Domain",
    updatePersonalInfo: "Update personal info",
    customerInfo: "Customer info",
    updateCustomerInfo: "Update customer info",
    customerId: "Customer ID",
    customerIdShort: "Customer ID",
    customerName: "Customer name",
    customerNameShort: "Customer name",
    nameUnit: "Name Unit",
    ownedBy: "Owned by",
    underTheUnit: "Under the unit",
    customerType: "Customer type",
    taxCode: "Tax code",
    invalidTaxCode: "Invalid tax code",
    documentType: "Document type",
    documentNumber: "Document number",
    documentNumberInvalid: "Invalid document number",
    issueDate: "Issue date",
    pleaseEnterDocumentIssueDate: "Please enter document issue date",
    pleaseEnterDocumentExpDate: "Please enter document expiry date",
    issuePlace: "Issue place",
    registerServiceInfo: "Service info",
    displayActiveSubPrice: "{price} VND per {months} month(s)",
    displayActiveSubMeetingCount: "{count} meetings per month",
    displayActiveSubConcurrentMeetings: "{count} concurrent meetings",
    displayActiveSubMaxParticipants: "{count} participants per meeting",
    displayActiveSubMaxMeetingLength: "{count} minutes per meeting",
    subCreatedDate: "Registered date",
    start: "Start",
    startDate: "Start date",
    endDate: "End date",
    noActiveSub: "No active subscriptions",
    storageInfo: "Storage info",
    displayStorageUsed: "{used} MB of {total} MB used",
    personal: "Personal",
    business: "Business",
    customerStatusActive: "Active",
    customerStatusInactive: "Inactive",
    customerStatusCancelled: "Cancelled",
    serviceAdminAccountList: "Service admin accounts",
    reload: "Reload",
    createNew: "Create new",
    contactSearchPlaceholder: "search by name, email, phone",
    adminSearchPlaceholder: "search by name, email, phone",
    resultCount: "Found {count} results",
    update: "Update",
    updateInfo: "Update info",
    actionDelete: "Delete",
    createServiceAdminAccount: "Create service admin account",
    updateAdminAccount: "Update account info",
    updateAccountInfo: "Update account info",
    deleteAccount: "Delete account",
    resetAdminAccountPassword: "Reset admin account password",
    creator: "Creator",
    createdDate: "Created date",
    unlockAccountSuccess: "Unlock Account successfully ",
    unlockAccountConfirmation: 'Unlock "{account}"?',
    deleteAccountConfirmation: 'Delete "{account}"?',
    deleteCustomerConfirmation: 'Delete "{name}"?',
    deleteAccountSuccess: "Account deleted",
    deleteAllViewerSuccess: "Delete all viewer accounts successfully",
    deleteCustomerSuccess: "Customer deleted",
    deleteYourAccount: "Are you sure you want to delete your account ?",

    withDrawCustomerConfirmation: 'Withdrawing consent, the system will delete the account and stop using the VNPT GoMeet service of customer "{name}". Are you sure you want to perform this action?',
    restrictCustomerConfirmation: 'Restrict/object to use of personal data, the system will delete the account and stop using the VNPT GoMeet service of customer "{name}". Are you sure you want to perform this action?',

    yes: "Yes",
    no: "No",
    ok: "Ok",
    cancel: "Cancel",
    success: "Success",
    unsuccessful: "Unsuccess",

    configBackupPolicy: "Config backup policy",
    backupCronSchedule: "Backup cron schedule",
    cronScheduleExplain: "Cron schedule explain",
    activateBackupSchedule: "Activate backup schedule",
    backupLocalPath: "Backup local path",
    backupSourceCode: "Backup source code",
    backupDb: "Backup db",
    backupOptions: "Backup options",
    storeLocal: "Store local",
    storeViaFtp: "Store via ftp",
    storeBothLocalAndFtp: "Store both local and ftp",
    activeSuccessful: "Active successful",
    saveSettingsSuccessful: "Save settings successful",
    ipBlockList: "Ip block list",
    addIpBlock: "Add ip block",
    itemsPerPage: "Items per page",
    deleteIpBlockConfirm: "Delete ip block confirm",
    deleteIpBlockSuccess: "Delete ip block success",
    configPasswordPolicy: "Config password policy",
    passwordMinLength: "Password min length",
    passwordMaxLength: "Password max length",
    passwordPattern: "Password pattern",
    passwordDescription: "Password description",
    passwordValidationFailedMessage: "Password validation failed message",
    passwordValidityPeriod: "Password validity period",
    wrongPasswordAttempt: "Wrong password attempt",
    passwordLockedOut: "Password locked out",
    passwordLockedOutDuration: "Password locked out duration",
    mustChangeDefaultPassword: "Must change default password",
    invalidPasswordPattern: "Invalid password pattern",
    appList: "App list",
    countPackage: "and {count} other packages",
    editInfo: "Edit info",
    edit: "Edit",
    deleteRecordConfirmation: "Delete {name}? (ID: {id})?",
    deleteRecordConfirmation2: `Delete "{name}"? (ID: {id})?`,
    deleteSuccessful: "Delete successful",

    loginPageTitle: "Login",
    loginVnptSso: "Login with VNPT",
    stayLoggedIn: "Stay logged in",
    forgotPasswordQMark: "Forgot password?",
    registerAccount: "Register",
    registerAccountSubtitle: "Free meetings and conferences",
    alreadyHaveAccountQ: "Already have an account?",

    calendar: "Calendar",
    createEvent: "Create event",
    thisWeek: "This week",
    date: "Date",
    datetime: "Datetime",
    content: "Content",
    location: "Location",
    noEvent: "No events",
    chairman: "Chairman",
    eventPreparation: "Preparation",
    eventParticipants: "Participants",
    eventInvitees: "Invitees",
    eventStatusPending: "Pending",
    eventStatusCancelled: "Cancelled",
    deleteEventConfirm: `Delete "{subject}"?`,
    deleteEventSuccessful: "Event deleted",
    editEvent: "Edit",
    eventStartTime: "Start",
    eventEndTime: "End",
    eventAllDay: "All day",

    deleteAllViewer: "Delete all Viewers",
    deleteAllViewerConfirmation: "Are you sure you want to delete all Viewers?",

    contactList: "Contact list",
    importContactFromFile: "Import from file",
    importUserFromFile: "Import user accounts from file",
    addNewContact: "Add new contact",
    updateContact: "Update contact",
    faceImage: "Face Image",

    deleteContactSuccessful: "Contact deleted",
    overview: "Overview",
    deleteCustomer: "Delete customer",
    restrictCustomer: "Restrict/object",
    withdrawConsent: "Withdraw consent",
    advancedConfiguration: "Advanced configuration",
    faceIdConfig: "Face recognition feature",
    voiceTextConfig: "Speech to text feature",
    storageCapacity: "Storage capacity (GB)",
    storageFullAlert: "Storage is full ({used} / {total} MB)",
    adminAccountList: "Admin account list",
    createAdminAccount: "Create admin account",
    role: "Role",
    roleAdmin: "Admin",
    roleUser: "User",
    sendServiceRenewReminderEmail: "Send service renew reminder email",
    noRegisteredService: "No registered service",
    serviceRegisterHistory: "Service register history",
    storageHistory: "Storage history",
    sendServiceRenewReminderEmailConfirm: "Send service renew reminder email?",
    sendServiceRenewReminderEmailSuccessful: "Reminder email sent!",

    meetingShareCamera: "Camera on",
    meetingTurnOffCamera: "Camera off",
    meetingMuteOnStart: "Mute on start",
    meetingChatNotAllow: "Chat not allowed",
    meetingStatusPending: "Pending",
    meetingStatusInProgress: "In progress",
    meetingStatusEnded: "Ended",
    meetingStatusCancelled: "Cancelled",
    meetingName: "Meeting name",
    meetingPrivateChatAllow: "Private chat allowed",
    meetingPublicChatAllow: "Public chat allowed",

    createNewCustomer: "Create new customer",
    createCustomer: "Create customer",
    createNewCustomerSuccessful: "Customer created",
    customerList: "Customer list",
    areaFilterSelectLabel: "Sale area",
    subscriptionStatusFilterSelectLabel: "Expires",
    planExpireGt2Months: "Expires in > 2 months",
    planExpireLt2Months: "Expires in < 2 months",
    nearExpired: "Near Expired",
    unexpired: "Unexpired",
    expired: "Expired",

    decree: "Decree",
    createDate: "Date created",
    deleteDate: "Date deleted",

    verificationEmailSent: "Verification email sent",
    verificationEmailSentSubtitle: "We have sent an email to {email}.\nClick the confirmation link to start using VNPT Gomeet.",
    notGetVerificationEmailYetC: "If you did not receive the email",
    resendVerificationEmail: "Resend verification email",
    openGmail: "Open Gmail",
    openOutlook: "Open Outlook",
    welcomeMsg: "Welcome to VNPT Gomeet",
    welcomeMsgSubtitle: "Hello! To get started with VNPT Gomeet we need a few details from you to create your free account.",
    signupSuccessful: "Account created successful",
    signupSuccessfulSubtitle: "Account created successful. Login to your account to start experiencing our services.",
    invalidSecretKey: "Invalid secret key",
    cannotLeaveFieldBlank: "Cannot be blank",

    maxParticipant: "The largest number of participants",

    createMeeting: "Create meeting",
    startNewMeeting: "Start new meeting",
    joinMeeting: "Join meeting",
    endMeeting: "End meeting",
    meetingTableActualDateTimeTitleAttr: "Start: {start}\nEnd: {end}",
    meetingTableScheduledDateTimeTitleAttr: "Scheduled start: {start}\nScheduled end: {end}",
    startMeetingWarning: "Please do not close the browser while the meeting is in progress",
    endMeetingWarning: `End meeting "{name}" (ID: {id})?`,
    endThisMeetingWarning: "End this meeting?",
    pleaseSelectValidDate: "Please select a valid date",
    meetingDuration: "Duration",
    meetingDurationFormFeedback: "Minimum 15 minutes, maximum",
    accessCode: "Access code",
    enterAccessCode: "Enter access code",
    accessCodeFormFeedback: "6-12 alphanumeric characters",
    createRandomAccessCode: "Random code",
    accessPermission: "Access permission",
    meetingOperator: "Operator",
    meetingOperatorBadge: "Operator",
    deleteMeeting: "Delete meeting",
    meetingParticipantsList: "Participants",
    meetingParticipantsMaxCount: "Max {count}",
    maxMeetingParticipantsExceeded: "Max no. of participants exceeded!",
    meetingConfig: "Settings",
    selectedWithCount: "Selected ({count})",

    QRCodeText: "Participation QR Code",
    copieQRLink: "Copy the meeting link",
    download: "Download",

    privateSub1: "Meeting information will be sent separately to those on the list, only these people are allowed to participate in the meeting.",
    faceIdSub: "Only people with face image information will be added to the meeting",
    faceIdIconSub: "Face recognition image available",
    warningIdIconSub: "There is no face recognition image yet. Go to Contacts to update this person's face image!",

    onlyShowCameraForOperator: "Only show camera for operator",
    enableToggleMeetingRecording: "Enable toggle meeting recording",
    enableAutomaticMeetingRecording: "Enable automatic meeting recording",
    enableVoiceText: "Enable Speech to text",
    enableMicro: "Enable micro",
    enableTakingNote: "Enable taking note",
    enableParticipationBeforeHost: "Allow participation before host",

    chooseContact: "Choose contact",
    meetingTypeClosed: "Private meeting",
    meetingTypeOpen: "Public meeting",

    private: "Private",
    public: "Public",

    joinByFaceId: "Join by Face Id",

    pleaseSelectMeetingStartDate: "Please select meeting start date",
    pleaseSelectMeetingStartDatetime: "Please select meeting start time",
    invalidMeetingStartDatetime: "Invalid meeting start date/time",
    invalidMeetingOperatorOrParticipantEmail: "Invalid operator/participant email",
    invalidMeetingDurationOrExceededLimit: "Invalid meeting duration or exceeded limit",
    createMeetingSuccessful: "Meeting created successful",
    editMeeting: "Edit",


    namePlaceHolder: "Enter first and last name",
    emailPlaceHolder: "Enter email",
    phonePlaceHolder: "Enter phone number",

    newMeetingDefaultName: "Meeting on ",

    openInApp: "Open in app",
    downloadApp: "Download app",
    meetingEndedMsg: "Meeting already ended",
    meetingRestartMsg: "You can restart the meeting",
    meetingDetails: "Meeting details",
    customerUserAccountList: "Customer user accounts",
    createCustomerUserAccount: "Create customer user account",
    updateCustomerInfoSuccessful: "Customer updated successful!",

    meetingPendingMsg: "meeting has not started",

    createSubPlan: "Create package",
    updateSubPlan: "Update package",
    subPlanName: "Package name",
    activeStatus: "Active status",
    updateSubPlanSuccessful: "Update package successful",
    createSubPlanSuccessful: "Create package successful",
    saleAccountList: "Sale accounts list",
    createSaleAccount: "Create sale account",
    subPlanList: "Packages list",

    updateApiConfig: "Update configuration",
    newApiConfig: "Create new configuration",
    createApiConfigSuccessful: "Create configuration successful",
    updateApiConfigSuccessful: "Upđate configuration successful",

    onOff: "On/Off",
    deleteAll: "Delete all",

    deleteAllContactsConfirm: "Do you want to delete all contacts",

    meetingId: "Meeting ID",
    viewMeetingRecordedFile: "View recorded file",
    meetingNoRecordedFile: "No recorded file",
    cancelMeeting: "Cancel meeting",
    meetingDate: "Date",
    meetingScheduledTime: "Scheduled",
    meetingActualTime: "Actual",
    numOfParticipants: "Num of participants",
    hostJoinUrl: "Host URL",
    participantJoinUrl: "Meeting URL",
    copyJoinUrl: "Copy join URL",
    TypeForm: "Type meeting",

    meetingParticipantsJoined: "In meeting ({count})",
    meetingParticipantsNotJoined: "Not in meeting ({count})",

    sendEmailInvitation: "Send invitation email",
    sendEmailInvitation2: "Send invitation email",
    sendEmailInvitationConfirm: "Send invitation email?",
    sendEmailInvitationConfirm2: "Send invitation email to {email}?",
    sendEmailInvitationToAll: "Send invitation email to all participants",
    sendEmailInvitationSuccessful: "Invitation email sent!",
    notSendEmailInvitation: "Invitation email not sent",
    alreadySentEmailInvitation: "Invitation email already sent",

    sendMeetingUpdateEmail: "Send meeting update email",
    sendMeetingUpdateEmailToAll: "Send meeting update email to all participants",
    sendMeetingUpdateEmailSuccessful: "Send meeting update email successful",
    notSendMeetingUpdateEmail: "Not send meeting update email",
    alreadySentMeetingUpdateEmail: "Already sent meeting update email",
    exportParticipants:"Export Participants",
    exportContentRoom:"Export Content Room",
    
    sendMeetingCancelEmail: "Send meeting cancel email",
    sendMeetingCancelEmailToAll: "Send meeting cancel email to everyone",
    sendMeetingCancelEmailSuccessful: "Meeting cancel email sent!",
    notSendMeetingCancelEmail: "Meeting cancel email not sent",
    alreadySentMeetingCancelEmail: "Meeting cancel email already sent",

    sendSmsInvitation: "Send invitation SMS",
    sendSmsInvitation2: "Send invitation SMS",
    sendSmsInvitationConfirm: "Send invitation SMS to {phone}?",
    sendSmsInvitationSuccessful: "Invitation SMS sent to {phone}",

    updateMeetingParticipant: "Update meeting participant",
    copiedHostJoinUrl: "Copied host join URL",
    copied: "Copied",
    faceidStatus: "Enable/disable FaceID",

    numMeeting: "Number of meetings",

    cancelThisMeetingConfirm: "Cancel this meeting?",
    cancelMeetingSuccessful: "Meeting cancelled",
    deleteThisMeetingConfirm: "Delete this meeting?",
    deleteMeetingSuccessful: "Meeting deleted",

    coreImplName: "Core platform",
    activeSubPlans: "Active plans",
    inactiveSubPlans: "Inactive plans",
    deleteSubPlanConfirm: `Delete plan "{name}"? (ID: {id})`,
    deleteSubPlanSuccessful: "Successfully deleted",

    logPolicy: "Log policy",
    deleteLogConfirm: "Delete this record? (ID: {id})",
    deleteLogSuccessful: "Delete log successful",

    totalCustomers: "Customers",
    totalMeetings: "Meetings",
    totalPackages: "Subscription packages",
    totalCustomerAccounts: "Customer accounts",
    totalInprogressMeetings: "Meetings in progress",
    totalPendingMeetings: "Pending meetings",
    totalEndedMeetings: "Ended meetings",
    totalCancelledMeetings: "Cancelled meetings",
    totalMeeting: "Total meetings",

    dashboardChartTitle: "TOTAL NUMBER OF MEETINGS AND PARTICIPANTS",
    fromDate: "From",
    toDate: "To",
    apply: "Apply",
    invalidDateRange: "Invalid date range",
    meetingsListToday: "Meetings list today",
    viewStats: "View stats",
    numCameraOn: "Camera on",
    numVoiceOn: "Voice on",

    emailTypeInviteMeeting: "Meeting invitation",
    emailTypeUpdateMeeting: "Meeting updated",
    emailTypeCancelMeeting: "Meeting cancelled",

    contentCannotBeBlank: "Content cannot be blank",
    updateEmailTemplateSuccessful: "Update email template successful",
    openInBrowser: "Open in browser",
    packageType: "Package type",
    demo: "Demo",
    trial: "Trial",
    testing: "Testing",
    official: "Official",
    meetingHasRecording: "Recorded meeting",
    contactFileFormatError: "Please upload a file with the same excel format and table structure as the sample file",
    contactFileSizeError: "Cannot send file larger than 1MB in size",
    passwordhasbeenusedbefore: "The new password cannot be the same as the current password",
    selectRangeDate: "Start date - End date",
    export: "Export Excel",
    noFoundSearch: "No result is found..",

    SigninCas_Ticket_Require: "Ticket field is required ",
    SigninCas_Service_Require: "Service field is required",
    UsernameRequired: "Username field  is required",
    PasswordRequired: "Password field  is required",
    UsernameMaxLength: "Max username length is 32 characters",
    PasswordMaxLength: "Max Password length is 32 characters",
    InvalidLogin: "Username or Password is invalid ",
    LoginLockoutEnabled: "Your account will be temporarily locked for {m} minutes after {i} failed login attempt.",
    LockAccountEnabled: "You have failed to log in 5 times, your account will be temporarily locked to {m}",
    InvalidCas: "Unable to sign in with SSO. Please recheck username/password you registered with SSO ",
    UserNotFound: "Account is not found ",
    PageRequired: "Page field is required",
    PageRangeInteger: "Page is range in 1 - 214748364",
    PageSizeRequired: "Page size field is required",
    PageSizeRange: "Page size is range in 10-1000",
    ConfirmPasswordRequired: "Please enter your confirm password ",
    PasswordNotMatch: "Your confirm password does not match the password",
    PasswordLength: "Your password's length must be at least 6 characters but not more than 32",
    UsernameDuplicate: "The username  is taken. Try another",
    AreaRequired: "Area field is required",
    BadRequest: "The data is invalid. Please recheck your input",
    EmailRequired: "Email field is required",
    PasswordPolicyLength: "The password's length must be at least 6 characters but not more than 16",
    PasswordPolicyRegex: "Password must be at least 8 characters including numbers, lowercase letters, uppercase letters and special characters.",
    ActivationCodeExpired: "Active Code is expired ",
    EmailExist: "The email  is taken. Try another",
    InvalidActivationCode: "Active Code is invalid ",
    NameMaxLength: "Max full name length is 100 characters",
    PhoneNumberRequired: "Phone number field is required",
    PhoneMaxLength: "Max phone number is 50 numbers",
    AddressMaxLength: "Max email length is 255 characters",
    EmailInvalid: "Email is  invalid",
    EmailMaxLength: "Max email length is 250 characters",
    incorrect_file_format: "File format is not supported",
    file_not_found: "File is not found ",
    IdRequired: "Id field is required",
    AccessIsDenied: "Forbidden access to this resource. Please check your permissions",
    OldPasswordInvalid: "Current password is invalid",
    NewPasswordInvalid: "Currentpassword and new password should not be same",
    UnableToDeleteAcc: "Account cannot be deleted because it is associated with a live activity",
    DeleteAllCustomerUserViewSuccessful: "Your account has been successfully deleted",
    InternalServerError: "500 Internal Server Error",
    InvalidSecretKey: "Secret key is invalid",
    SecretKeyExpired: "Secret key is expired",
    UsernameExist: "The username is taken. Try another",
    InvalidCustomerId: "Customer is not found ",
    CustomerIsExisting: "The customer is taken. Try another",
    CustomerDuplicateIdCode: "Personal identification number already existed. Try another",
    CustomerDuplicateTaxCode: "Tax code already existed. Try another ",
    CustomerDuplicateCode: "Customer code already existed. Try another",
    CustomerDuplicatePhoneNumber: "The phone number is taken. Try another",
    CustomerNameIsRequired: "The full name field is required",
    CustomerNameMaxLength: "Max  full name length is 255 characters",
    PhoneNumberMinLength: "Min phone number length is 10 characters",
    AreaIdIsRequired: "Area Id field is required",
    AppNameRequired: "App Name field is required",
    AppDomainNameRequired: "Domain Name field is required",
    AppLogoRequired: "Logo field  is required",
    AppLogoExtRequired: "File Type field is required",
    AppActiveRequired: "Active field is required",
    InvalidLogo: "Logo format is invalid.  Please select an alternative image source file, such as \".jpg, .jpeg, .png\"",
    AppNameCustomerExist: "App already exists for this customer ",
    AppNameNotFound: "App is  not found ",
    InvalidAreaId: "Area Id is  invalid ",
    UnableToDelete: "Data cannot be deleted because it is associated with other data",
    InvalidContactId: "Contact is not found ",
    InvalidContactCode: "ContactCode is null or invalid",
    ContactNameIsRequired: "Contact Name field is required",
    ContactNameMaxLength: "Max contact name length is 255 characters",
    UnauthorizeEditContact: "Forbidden access to this resource to update. Please check your permissions",
    ImportContactSuccessful: "Contacts has been imported successfully",
    InvalidParamInput: "Please upload an valid file format. Referecing to file upload sample to get the right format. ",
    InvalidCustomerSubscriptionId: "Customer's subscription plan is not found. Please subscribe to a service plan to use this product",
    CustomerIdIsRequired: "Customer id field is required",
    SubscriptionPlanIdIsRequired: "Plan Id field is required",
    StartTimeIsRequired: "Start time field is required",
    NumberOfConcurrentMeetings: "Number of concurrent meetings is range in 1:100",
    InvalidCustomer: "Customer is not found ",
    InvalidSubscriptionPlan: "Plan is not found ",
    CusSubsPlanToRenewIsNotFound: "Customer's subscription plan is invalid. Please subscribe to a valid service plan to use this product",
    CustomerNotMatchForRenewOrUpgrade: "Not found the customer's subscription plan to upgrade",
    SubjectRequired: "Subject field is required",
    SubjectMaxLength: "Max subject length is 255 characters",
    ContentRequired: "Content field is required",
    ModelNotFound: "Data is not found ",
    IPAddressIsRequired: "Ip Address field is required",
    IPAddressNULL: "Id Address field must not be null ",
    InvalidIPAddress: "Ip address is invalid ",
    MeetingSecretKeyRequired: "Secret Key field is required",
    MeetingNotFound: "The meeting is not found ",
    AccessCodeRequired: "Access code  field is required",
    FullNameRequired: "Full name field is required",
    InvalidAccessCode: "Access code  is invalid ",
    MeetingStatusPending: "The meeting has not started yet ",
    MeetingStatusEnded: "The meeting has been ended",
    StartMeetingExceed: "The number of concurrent meetings exceeded the limit of your plan",
    NotAllowedToJoinMeeting: "The max of number of participants in the meeting reached. You can not joined the meeting. ",
    MeetingNameIsRequired: "Meeting title field is required",
    ScheduleStartTimeIsRequired: "Start time field is required",
    ScheduleDurationIsRequired: "Duration field is required",
    MinScheduleDuration: "Duration must be at least 15 minutes",
    AccessCodeIsRequired: "Access code field is required",
    AccessCodeLength: "Your access code length must be at least 6 characters but not more than 12",
    ParticipantRequired: "Participant field is required",
    CustomerSubscriptionNotFound: "Please subscribe a service plan to use this product",
    CustomerSubscriptionIsExpired: "Subscription plan has expired. Please subscribe a new service plan to use this product ",
    MeetingCountDailyIsExceeded: "The number of meetings per day exceeded the limit of your plan",
    NumberOfParticipantIsExceeded: "The number of participants in the meeting exceeded the limit of your plan ",
    MinimumNumOfParticipants: "The number of participants must be at least one",
    InvalidMeetingStatus: "Status of meeting is invalid.  Please use \"pending\" or \"inprogress\" or \"end\" instead",
    OnlyDelMeetingInPendingStatus: "Unable to delete occurrence meeting",
    MeetingIdIsRequired: "Meeting Id field is required",
    InvalidMeetingId: "The meeting is not found ",
    InvalidRequest: "the data is invalid due to validation restrictions, please recheck your input",
    TemplateNotFound: "Email template is not found ",
    ParticipantNameIsRequired: "Participant name field is required",
    ParticipanNameMaxLength: "Max participant name length is 255 characters",
    InvalidMeetingRole: "Role field is invalid. Please use \"PARTICIPANT\" or \"OPERATOR\" role instead",
    MeetingAccessDenied: "Forbidden access to this resource. Please check your permissions",
    PasswordValidityPeriod: "Valid date range is 1 - 3650 ",
    WrongPasswordAttempt: "Number of login attempts is range 1-100 times",
    LockedOutDuration: "Lock Duration is range in 1 - 1440 minutes",
    PasswordPolicyInvalid: "Max password length must be greater than min password length ",
    LocalPathIsRequired: "Local path field is required",
    LocalPathInvalid: "Local path field is invalid",
    ConfigFtpHostInvalid: "Config FPT field is invalid",
    BackupPolicyBadRequest: "Backup Scheduling is invalid. You should use format \"minute hour date month dayoftheweek\". Example \"5 1 9 4 * ?\"",
    ConfigBackupPolicyInvalid: "Backup configuration is invalid ",
    PortLength: "Port is range in 0-65535",
    PortPolicyError: "Your update failed",
    ConfigIsActive: "The configuration is inactive. Please active before doing this activity",
    SubcriptionPlanNameRequired: "Plan name field is required",
    SubcriptionPlanNameMaxLength: "Max plan name is 255 characters",
    SubcriptionPlanPackageTypeIsRequired: "Plan type field is required",
    MaximumNumberOfParticipantsIsRequired: "Number of participants is required",
    MaximumNumberOfParticipantsLengh: "Number of participants is range 1:1000",
    NumberOfConcurrentMeetingsIsRequired: "Number of concurrent meetings is required",
    NumberOfConcurrentMeetingsLength: "Number of ooncurrent meetings is range 1:100",
    MaximumLengthOfOneMeetingIsRequired: "Duration of meeting is required",
    MaximumLengthOfOneMeetingLength: "Meeting duration is range in 30 - 1440 ",
    NumberOfMeetingsPerMonthIsRequired: "Number of meetings per month is required",
    NumberOfMeetingsPerMonth: "Number of meetings per month is range in 1-10000",
    NumberOfDaysUsageIsRequired: "The validity period for plan is required",
    NumberOfDaysUsage: "The validity period for plan is range in 1-36 days",
    SubcriptionPlanPriceIsRequired: "Price of plan is required",
    CoreImplNameIsRequired: "Core type is required to be BBB or Zoom ",
    UnableToDeletePackage: "Plan cannot be deleted because it is associated with an active account ",
    MeetingStatusInvalid: "Status of the meeting is invalid ",
    ApiKeyNameyIsNull: "Api key field or api key name field is required",
    WebhookConfigurationIsExisting: "Webhook configuration already exists for this account ",
    InvalidWebhookConfigureId: "Webhook configuration is invalid",
    UpdateSuccess: "The information was successfully updated",
    TokenInvalid: "Your session has expired. Please log in again",
    timeEndValid: "Invalid end time",
    passwordFormat: "Password must be at least 8 characters including numbers, lowercase letters, uppercase letters and special characters.",
    UpdateRoleInvalid: "Field role in invalid. Please use 'Customer', 'User' or 'View' role instead",
    NewPasswordRequired: "Required NewPasword Field",
    InvalidCustomerName: "Field CustomerName must contain only alphabets",
    faceImageTitle1: "Select images for user",
    faceImageTitle2: "The image name matches the corresponding code of the user in the phonebook",
    faceChosePlaceholder: "Can select multiple photos at once",
    UrlNotAllowed: "Url Not Allowed",
    FormatEmailInvalid: "Invalid format email",
    FormatInvalidName: "Invalid format name",
    FormatPhoneInvalid: "Invalid format phone",
    PasswordInWordlist: "Do not use easy-to-guess passwords.",
    widgetDescription: " Widgets allow people to easily embed meeting room windows in their websites. Make it easier for everyone to use gomeet",
    createWidget: "Create Widget",
    createContentWidget: "Place this code wherever you want to add a Widget",
    attribute: "Attribute",
    required: "Required",
    description: "Description",
    Upload_success: "Upload image successfully",
    Upload_failed: "Image upload failed",
    Upload_failed_code_exist: "Error: Code already exists",
    InvalidParticipantName: "Error: Invalid Participant Name", 
  },
};
